import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  bankStatementAtLeastOneStatementRequired: {
    id: "funding-application: air bank statement at least one statement required text",
    defaultMessage: "Please upload at least one file",
  },
  bankStatementBankNameRequiredText: {
    id: "funding-application: air bank statement name required text",
    defaultMessage: "Please provide a bank name",
  },
  bankStatementBankNameText: {
    id: "funding-application: air bank statement back name text",
    defaultMessage: "Bank name",
  },
  bankStatementOrText: {
    id: "funding-application: air bank statement or text",
    defaultMessage: "or",
  },
  bankStatementRequiredText: {
    id: "funding-application: air bank statement required description",
    defaultMessage: "We're unable to retrieve all of the information we require from your bank connection.",
  },
  bankStatementSecondaryContentHeading: {
    id: "funding-application: air bank statement secondary content heading",
    defaultMessage: "Why do you need my business banking data?",
  },
  bankStatementSecondaryContentText: {
    id: "funding-application: air bank statement secondary content text",
    defaultMessage:
      "We use your banking data to assess the overall financial health of your business and to cross-reference with data from your eCommerce platforms. This information forms an important part of our financial assessment.",
  },
  bankStatementTodayText: {
    id: "funding-application: air bank statement today text",
    defaultMessage: "today",
  },
  bankStatementUnableToProvideCheckboxLabel: {
    id: "funding-application: air bank statement unable to provide checkbox label",
    defaultMessage: "I am unable to provide statements for this bank account",
  },
});
